import React from 'react';
import { getConfig } from 'config/runtime';

const baseUrl = getConfig('REACT_APP_IMAGES');

const VehicleDetailComponent = ({ data }) => {
  return (
    <div className="vehicle-detail-component">
      <label className="label">Mobil</label>
      <div className="vehicle-data">
        <div className="vehicle-data__image">
          {data?.order_detail?.vehicle?.photo && data?.order_detail?.vehicle?.photo.length !== 0 ? (
            <img
              alt={data?.order_detail?.vehicle?.name ?? 'Vehicle'}
              src={`${baseUrl}${data?.order_detail?.vehicle?.photo[0].name}`}
            />
          ) : (
            <div />
          )}
        </div>

        <div className="vehicle-data__detail">
          <h3>
            {data?.order_detail?.vehicle?.brand_name && <span>{data?.order_detail?.vehicle?.brand_name} </span>}
            <span>{data?.order_detail?.vehicle?.name}</span>
          </h3>
          <div className="vehicle">
            <p>{data?.order_detail?.vehicle?.max_passanger} Seats</p>
            <span />
            <p>{data?.order_detail?.vehicle?.max_suitcase} Koper</p>
            <span />
            <p>Transmisi {data?.order_detail?.vehicle?.transmission}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetailComponent;
